import React from 'react';
import { Layout } from 'fronton-react';
import { useStoreon } from 'storeon/react';
import { RemoteCarousel, RootLayout, Section } from 'common/components';
import { MODEL_JSON_STORE_NAME, Offers } from 'modules/model-json';
import { convertProducts, createElementKey } from 'utils';
import { SEASON_START_BREADCRUMBS } from '../constants';
import { SeasonStartBanners } from '../components/season-start-banners';
import { SeasonStartHeader } from '../components/season-start-header';
import {
  SEASON_START_BATHROOM_CDN_PATH,
  SEASON_START_BATHROOM_COLLECTION_LIST,
  SEASON_START_BATHROOM_ELEMENT_BLOCK,
  SEASON_START_BATHROOM_PATH,
  SEASON_START_BATHROOM_PRODUCTS,
  SEASON_START_BATHROOM_SOLUTIONS,
} from './bathroom-page-constants';
import { SeasonStartHeaderBanner } from '../components/season-start-header-banner';
import { SeasonStartCollections } from '../components/season-start-collections';

export const SeasonStartBathroom = () => {
  const { modelJson } = useStoreon(MODEL_JSON_STORE_NAME);
  const { offers } = modelJson.model;

  return (
    <RootLayout currentPage={SEASON_START_BATHROOM_PATH} customBreadcrumbs={SEASON_START_BREADCRUMBS}>
      <Layout>
        <Section>
          <SeasonStartHeader title="Обновим ванную с выгодой" />
          <SeasonStartHeaderBanner
            creative="Обустроим ванную под ключ"
            elemetnBlock={SEASON_START_BATHROOM_ELEMENT_BLOCK}
            link={{
              href: '/uslugi/proektirovanie-i-dizayn/sozdayte-vannuyu-komnatu-svoey-mechty/',
              title: 'Бесплатный проект ванной комнаты',
            }}
            img={{
              alt: 'Баннер обустроим ванную под ключ',
              src: `${SEASON_START_BATHROOM_CDN_PATH}/banners/main-banner-m.jpg/main-banner-m.jpg`,
              srcLd: `${SEASON_START_BATHROOM_CDN_PATH}/banners/main-banner-ld.jpg/main-banner-ld.jpg`,
              srcT: `${SEASON_START_BATHROOM_CDN_PATH}/banners/main-banner-t.jpg/main-banner-t.jpg`,
            }}
          />

          <SeasonStartCollections
            collectionList={SEASON_START_BATHROOM_COLLECTION_LIST}
            elementBlock={SEASON_START_BATHROOM_ELEMENT_BLOCK}
            division='Ванной комнаты'
            subdivision='Готовые комплекты'
            showAllLink={{
              href: '/promo/nabory-mebeli-dlya-vannoy/?offer=skidka-na-komplekty-dlya-vannoy-komnaty',
              title: 'Наборы мебели для ванной комнаты',
            }}
          />
        </Section>

        <SeasonStartBanners
          bannerList={SEASON_START_BATHROOM_PRODUCTS}
          elementBlock={SEASON_START_BATHROOM_ELEMENT_BLOCK}
          title="Товары и услуги с выгодой"
          type="sale"
        />
      </Layout>

      {offers?.map((offer: Offers, index: number) => (
        <RemoteCarousel
          key={createElementKey('remote-carousel', index)}
          elementBlock={SEASON_START_BATHROOM_ELEMENT_BLOCK}
          productIdList={convertProducts(offer.products)}
          remoteId={createElementKey('remote-carousel', index)}
          seeMoreLink={offer.link}
          showSeeMore
          title={offer.title}
        />
      ))}

      <Layout>
        <SeasonStartBanners
          bannerList={SEASON_START_BATHROOM_SOLUTIONS}
          elementBlock={SEASON_START_BATHROOM_ELEMENT_BLOCK}
          title="Готовые решения по суперценам"
          type="ggr"
        />
      </Layout>
    </RootLayout>
  );
}

